import { Injectable } from '@angular/core';
import { ParamLibre } from '@app/models/cogito';

@Injectable({
  providedIn: 'root'
})
export class ParamsLibresService {

  constructor() { }

  sortParamsLibres(paramsLibres: ParamLibre[]) {
    if (paramsLibres.length) {
      paramsLibres.sort((p1, p2) => p1.ordre === p2.ordre ? 0 : !p1.ordre || p1.ordre > p2.ordre ? 1 : -1);
    }
    return paramsLibres;
  }

  sortParamsLibresByOrdreAndFilterEnabled(paramsLibres: ParamLibre[]): ParamLibre[] {
    return paramsLibres.sort((a: ParamLibre, b: ParamLibre) => {
      if (a.ordre < b.ordre) return -1;
      if (a.ordre > b.ordre) return 1;
      return 0;
    }).filter(param => param.enabled);
  }

  checkParamsLibres(paramsLibres: ParamLibre[]): boolean {
    return paramsLibres
      .filter(paramLib => paramLib.obligatoire)
      .every(paramLibre => paramLibre.valeur || paramLibre.idParamLibreValeur);
  }
}
